import { OrgService } from './../../../services/org.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdminService } from 'app/services/admin.service';
import { IOrg } from 'app/models/IOrg';
import { IUser } from 'app/models/IUser';

@Component({
  selector: 'app-list-org',
  templateUrl: './list-org.component.html',
  styleUrls: ['./list-org.component.scss']
})
export class ListOrgComponent implements OnInit {

  public data: IOrg[];
  public filterQuery = '';
  constructor(private adminService: AdminService, private orgService: OrgService) { }

  ngOnInit() {
    this.adminService.getOrgs().subscribe(
      result => {
        this.data = result;
      }
    )
  }

  ngOnDestroy() {
    //this.adminService.getOrgs()

  }

  setOrg(org: IOrg) {
    this.orgService.changeOrg(org);
    
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/org/list-org/list-org.component.ts